<template lang="pug">
.transaction_tooltip
  .el-tooltip__popper.is-light(style='width: 250px;' v-if='transaction')
    div
      p
        p.tooltip_planned_info(v-if='transaction.fPlannedInfo()') {{ transaction.fPlannedInfo() }}
        strong.tooltip_category {{ transaction.category || $t(transaction.fSubtype()) }}
      p(v-html='transaction.fDescription(_display_tags = true)')
      .tooltip_accounts {{ transaction.fAccountNames() }}
    .popper__arrow(x-arrow)
</template>


<script>
export default {
  name: 'transaction_tooltip',
  data(){
    return {
      popper: null
     }
  },
  computed: {
    transaction(){
      return this.$store.state.ui.transactions.calendar.highlighted_transaction
    }
  },
  watch: {
    transaction(){
      this.transaction ? this.show() : this.hide()
    }
  },
  methods: {
    show(){
      this.$nextTick(() => {
        let $tr_el = $(`#transaction-${this.transaction.id}`)
        let $tooltip_el = $(this.$el).find('.el-tooltip__popper')
        this.popper = new Popper($tr_el, $tooltip_el, { placement: 'left' })
      })
    },
    hide(){
      this.popper.destroy()
    }
  }
}
</script>
